import { Typography } from 'antd';

export default Typography;
